import gql from "graphql-tag";

const POST_TO_FORGE = gql`
  mutation PostToForge(
    $postToForgeRequest: PostToForgeRequest!
    $testGroup: String
  ) {
    postToForge(
      postToForgeRequest: $postToForgeRequest
      testGroup: $testGroup
    ) {
      statusCode
      success
      message
    }
  }
`;

const CUT_CUSTOM_CLIP = gql`
  mutation CreateUserCustomClip(
    $userCustomClipRequest: UserCustomClipRequestInput!
  ) {
    createUserCustomClip(userCustomClipRequest: $userCustomClipRequest) {
      success
      videoUrl
      thumbnailUri
    }
  }
`;

export { POST_TO_FORGE, CUT_CUSTOM_CLIP };



// WEBPACK FOOTER //
// ./src/httpClients/graphql/jared-mutations.js